const generatedName = (baseName, index) => `${baseName}${index ? `-${index + 1}` : ''}`;

/**
 * Add AI-generated costumes using the Scratch VM's `(md5ext, costume, targetId)`
 * signature. The upload adapter supplies both the storage-backed costume object
 * and its MD5 extension; passing the object as the first argument makes Scratch
 * attempt string operations on it and crashes the editor.
 *
 * @param {object} vm Scratch VM instance
 * @param {Array<object>} costumes Costumes created by costumeUpload
 * @param {string} targetId Target sprite or stage ID
 * @param {string} baseName User-visible base name for the costumes
 * @returns {Promise<Array>} resolves after every costume has been installed
 */
export const addGeneratedCostumes = (vm, costumes, targetId, baseName) => Promise.all(costumes.map((costume, index) => {
    if (!costume || typeof costume.md5 !== 'string' || !costume.md5) {
        throw new Error('AI asset không có định danh Scratch hợp lệ. Hãy tạo lại asset rồi thử thêm lại.');
    }
    costume.name = generatedName(baseName, index);
    return vm.addCostume(costume.md5, costume, targetId);
}));
